import React from 'react';

const coreValues = [
  {
    image: 'growth.png',
    title: 'Curiosity Delivers Growth',
    description:
      'We are endlessly curious. Asking questions is the surest way to growth, and we never stop asking how things can be done better. Learning and innovating is part of our DNA.',
  },
  {
    image: 'integrity.png',
    title: 'Integrity is Life',
    description:
      'Integrity comes before everything else. We are committed to being honest with prospects, clients, employees, authorities, and all stakeholders. Everything is fair, transparent, and ethical.',
  },
  {
    image: 'relationship.png',
    title: 'Relationships Win',
    description:
      'We believe in building long-lasting relationships. Trust, mutual respect, and effective communication form the foundation of everything we do.',
  },
  {
    image: 'process.png',
    title: 'Obsess Over Results',
    description:
      'Results drive our direction. We’re focused, goal-oriented, and constantly measuring performance to ensure we exceed expectations.',
  },
  {
    image: 'res.png',
    title: 'Processes Empower',
    description:
      'Efficient processes provide clarity, consistency, and quality. By following optimized processes, we empower our teams to do their best work.',
  },
];

const CoreValue = () => {
  return (
    <div className="container py-4">
      <h1 className="mb-5 text-center">Core Values</h1>

      <div className="row g-4">
        {coreValues.map((value, index) => (
          <div className="col-md-6 col-lg-4" key={index}>
            <div className="card h-100 shadow-sm">
              <img
                src={value.image}
                alt={value.title}
                className="card-img-top"
                style={{ height: '200px', objectFit: 'contain', padding: '20px' }}
              />
              <div className="card-body">
                <h5 className="card-title">{value.title}</h5>
                <p className="card-text">{value.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoreValue;
